import { Box, Paper, Divider } from '@mui/material';
import DateRangePreset from './DateRangePreset';
import MultiSelectChips from './MultiSelectChips';
import type { DateRange } from '@/types';

interface TickerFilterBarProps {
  dateRange: DateRange;
  channels: string[];
  availableChannels: string[];
  onDateRangeChange: (range: DateRange) => void;
  onChannelsChange: (channels: string[]) => void;
}

export default function TickerFilterBar({
  dateRange,
  channels,
  availableChannels,
  onDateRangeChange,
  onChannelsChange,
}: TickerFilterBarProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 3,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 3,
          flexWrap: 'wrap',
        }}
      >
        {/* Date Range Preset */}
        <DateRangePreset value={dateRange.preset} onChange={onDateRangeChange} />

        <Divider orientation="vertical" flexItem />

        {/* Channel Filter */}
        <Box sx={{ flex: 1, minWidth: 200 }}>
          <MultiSelectChips
            label="博主"
            options={availableChannels}
            value={channels}
            onChange={onChannelsChange}
          />
        </Box>
      </Box>
    </Paper>
  );
}
